import { Global, css, useTheme } from '@emotion/react';

const GlobalStyles = () => {
  const theme = useTheme();
  const primary = theme?.colors?.primary || '#98FB98';
  const bg = theme?.colors?.background || '#1C1C1C';
  const text = theme?.colors?.text || '#FFFFFF';
  const font = theme?.fonts?.primary || "'Montserrat', sans-serif";

  return (
    <Global
      styles={css`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        html {
          color-scheme: var(--al-color-scheme, dark);
        }

        body {
          background: var(--al-bg, ${bg});
          color: var(--al-text, ${text});
          font-family: var(--al-font, ${font});
          transition: background-color 0.25s ease, color 0.25s ease;
        }

        #root,
        .min-h-screen,
        .page-container {
          background: var(--al-bg, ${bg});
          min-height: 100vh;
          transition: background-color 0.25s ease;
        }

        .page-container {
          padding-top: 60px;
        }

        button {
          background: var(--al-primary, ${primary});
          color: var(--al-on-primary, ${bg});
          border: none;
          padding: 8px 16px;
          border-radius: 0;
          font-family: var(--al-font, ${font});
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          cursor: pointer;
          transition: opacity 0.2s ease, background-color 0.2s ease, color 0.2s ease;

          &:hover {
            opacity: 0.9;
          }

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          &.secondary {
            background: #4a4a4a;
            color: var(--al-text, ${text});
          }

          &.text {
            background: transparent;
            color: var(--al-primary, ${primary});
            padding: 4px 8px;

            &:hover {
              background: rgba(var(--al-primary-rgb, 152, 251, 152), 0.1);
            }
          }
        }

        select {
          background: var(--al-primary, ${primary});
          border: none;
          color: var(--al-on-primary, ${bg});
          border-radius: 0;
          font-family: var(--al-font, ${font});
          font-size: 12px;
          padding: 4px 8px;
          cursor: pointer;
          text-transform: uppercase;

          &:focus {
            outline: none;
          }

          option {
            background: var(--al-primary, ${primary});
            color: var(--al-on-primary, ${bg});
            padding: 8px;
          }

          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;

          background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%231A1613'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
          background-repeat: no-repeat;
          background-position: right 8px center;
          background-size: 16px;
          padding-right: 30px;
        }

        input[type='checkbox'] {
          appearance: none;
          -webkit-appearance: none;
          width: 16px;
          height: 16px;
          border: 2px solid var(--al-primary, ${primary});
          background: transparent;
          cursor: pointer;
          position: relative;
          margin-right: 8px;

          &:checked {
            background: var(--al-primary, ${primary});

            &:after {
              content: '×';
              color: var(--al-on-primary, ${bg});
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              font-size: 14px;
              font-weight: bold;
              line-height: 1;
            }
          }

          &:hover {
            opacity: 0.8;
          }

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      `}
    />
  );
};

export default GlobalStyles;
